"use client";

import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

/**
 * Client component to capture referral codes from URL query parameters
 * Stores the referral code in localStorage for use during signup
 */
export function ReferralCodeCapture() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const refCode = searchParams.get("ref");
    if (refCode) {
      localStorage.setItem("referral_code", refCode);
    }
  }, [searchParams]);

  return null; // This component doesn't render anything
}
